import { useContext } from "react";

import { RatingIcon } from "../../components/icons/RatingIcon";
import { RatingZero } from "../../components/icons/RatingZero";
import object from "../../assets/images/stubs/object-mob.png";
import { LikeIcon } from "../../components/icons/LikeIcon";
import AuthContext from "../../store/auth-context";
import { url } from "../../store/host-store";
import { NavLink } from "react-router-dom";
import s from "./style.module.sass";
import FixationSvg from "./svg/FixationSvg";
import ShowPromoteSvg from "./svg/ShowPromoteSvg";
import CheckedUserMiniIcon from "../../components/catalogPages/svg/CheckedUserMiniIcon";
import {LocationCitySvg} from "../../cabinet/advertisement/desktopPages/svg/LocationCitySvg";
import {htmlConvert} from "../../store/hooks/htmlConvert";

const ObjectCard = ({
    id,
    alias,
    fullAllias,
    mark,
    name,
    about,
    image,
    status_busy,
    price_1,
    price_1_name,
    price_2,
    price_2_name,
    toggleFav, //устанавливаем функцию выше, добавить или удалить
    isFavorite, //проверка, добавлено ли объявление в избранное
    favId, //id объвления
    fixation,
    activeShow,
    item,
    cityName,
}) => {
    const ctx = useContext(AuthContext);
    const checkedByStatusOrganization = item?.user?.confirmed === 1;
    const cityAlias = item?.city?.alias || (() => {
        try {
            const location = JSON.parse(localStorage.getItem('location'));
            return location?.alias || '';
        } catch (e) {
            return '';
        }
    })();
    return (
        <div className={s.card}>
            <div className={s.card__rating}>
                {mark !== null ? (
                    <>
                        <RatingIcon/>
                        {mark}
                    </>
                ) : (
                    <>
                        <RatingZero/>
                        <span>0.0</span>
                    </>
                )}
            </div>

            {(fixation !== null || activeShow !== null) &&
                <div className={s.fixation}>
                    {fixation !== null && <FixationSvg/>}
                    {activeShow !== null && <ShowPromoteSvg/>}
                </div>
            }
            {/* кнопка избранное отображается только при авторизации */}
            {ctx.userData?.id && (
                <button
                    title="мне нравится"
                    type="button"
                    className={`${s.card__like} ${isFavorite ? s.active : ""}`}
                    onClick={() => toggleFav(favId ? favId : id)}>
                    <LikeIcon/>
                </button>
            )}
            {/*<span>{cityAlias}</span>*/}
            <NavLink to={`/${cityAlias}/${fullAllias}/${alias}`} className={s.img_wrapper}>
                {checkedByStatusOrganization &&
                    <div className={s.organization_checked}>
                        <div className={s.organization_flex}>
                            <CheckedUserMiniIcon/>
                            <span className={s.organization_text}>Личность подтверждена</span>
                        </div>
                    </div>
                }
                {cityName && <p className={s.abs}><span> <LocationCitySvg/>{cityName}</span></p>}
                {image === null ? (
                    <img width={278} height={160} src={object} alt="object"/>
                ) : (
                    <img
                        width={278}
                        height={160}
                        src={image?.webpFilename?.length > 0 ? url + image?.webpFilename : url + image?.filename}
                        alt="object"
                    />
                )}
            </NavLink>
            <div className={s.content}>
                <div className={s.title_box}>
                    <NavLink to={`/${cityAlias}/${fullAllias}/${alias}`}>
                        <h3 className={s.title}>{name}</h3>
                    </NavLink>

                    {status_busy === 0 ? (
                        <div className={`${s.status} ${s.free}`}>Свободно&nbsp;сегодня</div>
                    ) : status_busy === 1 ? (
                        <div className={`${s.status} ${s.busy}`}>Занят</div>
                    ) : (
                        <div className={`${s.status} ${s.soon}`}>Скоро&nbsp;освободится</div>
                    )}
                </div>
                <div>
                    <div className={s.prices}>
                        <div className={s.prices__left}>
                            <input type="radio" name={"radio" + id} id={"radio" + id} defaultChecked/>
                            <label htmlFor={"radio" + id}>
                                <h5>{price_1 ? price_1 : 'НЕ УКАЗАНА'} ₽</h5>
                                <span>{price_1_name}</span>
                            </label>
                        </div>
                        <div className={s.prices__right}>
                            <input type="radio" id={"radioSub" + id} name={"radio" + id}/>
                            <label htmlFor={"radioSub" + id}>
                                <h5>{price_2 ? price_2 : 'НЕ УКАЗАНА'} ₽</h5>
                                <span>{price_2_name}</span>
                            </label>
                        </div>
                    </div>
                    <h5 className={s.character}>Описание</h5>
                    <p className={s.descr}>
                        {htmlConvert(about)}
                    </p>
                    <NavLink to={`/${cityAlias}/${fullAllias}/${alias}`} className={s.btn}>
                        {item?.contact !== null ? 'Подробнее' : 'Подать заявку'}
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default ObjectCard;